import { Button, Icon, Message, Header } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

const NotFulfilledContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  max-width: 600px;
  margin: 0 auto;

  .message-content {
    margin-bottom: 30px;
  }

  .phone-number {
    font-size: 24px;
    font-weight: 600;
    color: #2c3e50;
    margin: 20px 0;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    display: inline-block;
    cursor: pointer;
  }

  .whatsapp-button {
    background: #25d366 !important;
    color: white;
    padding: 15px 30px;
    font-size: 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
    }

    .icon {
      font-size: 20px;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    padding: 30px 15px;

    .phone-number {
      font-size: 20px;
      padding: 12px;
    }

    .whatsapp-button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const callToWhatsapp = () =>
  window.open(
    'https://wa.me/573245724642?text=Hola, quisiera recibir asesoría para mi solicitud de matrimonio'
  );

const StepNotfulfilled = () => {
  return (
    <NotFulfilledContainer>
      <Message warning size="large">
        <Message.Header>
          <Icon name="exclamation triangle" /> Información Importante
        </Message.Header>
        <p className="message-content">
          No podemos continuar con tu solicitud para matrimonio en este momento.
        </p>
      </Message>

      <Header as="h3" style={{ marginTop: '30px', color: '#2c3e50' }}>
        <Icon name="phone" /> Contáctanos
      </Header>
      <p>Por favor escríbenos a este número para recibir una asesoría personalizada:</p>
      <div className="phone-number" onClick={callToWhatsapp}>
        <Icon name="phone" /> 324 572 46 42
      </div>

      <div className="button-container">
        <Button className="whatsapp-button" onClick={callToWhatsapp}>
          <Icon name="whatsapp" />
          Enviar mensaje a WhatsApp
        </Button>
      </div>
    </NotFulfilledContainer>
  );
};

export default StepNotfulfilled;
